export default "__VITE_ASSET__5bLq0esx__"